import { isGroup } from './groups'

export const getLastFieldRow = (fields) => {
  const { ids, entities } = fields

  const onlyFieldIds = ids.filter((id) => !isNaN(+id))
  if (!onlyFieldIds.length) return 0

  const lastFieldId = onlyFieldIds[onlyFieldIds.length - 1]
  const lastFieldRow = entities[lastFieldId].fieldRow

  return lastFieldRow
}

export const getLastGroupFieldRow = (fields, groupId) => {
  const { entities } = fields

  const groupChildrens = entities[groupId].children
  if (groupChildrens.length === 0) return getLastFieldRow(fields)

  const lastFieldId = groupChildrens.length ? groupChildrens[groupChildrens.length - 1].id : groupId
  const lastFieldRow = entities[lastFieldId].fieldRow

  return lastFieldRow
}

export const adjustPositions = ({ fields, sourceFieldRow, targetFieldRow, isGroupOperation = false }) => {
  const { ids, entities } = fields

  const updatedFields = []

  const direction = sourceFieldRow > targetFieldRow ? 'up' : 'down'

  // If the direction is 'up' and it is a group operation (add/remove), increment targetFieldRow by 1 to prevent moving the target field down
  if (direction === 'up' && isGroupOperation) targetFieldRow += 1

  for (const id of ids) {
    const { fieldRow: currentFieldRow } = entities[id]

    if (isGroup(id)) continue

    if (currentFieldRow === sourceFieldRow) {
      updatedFields.push({ id, fieldRow: targetFieldRow })
    } else {
      if (direction === 'up' && currentFieldRow >= targetFieldRow && currentFieldRow < sourceFieldRow) {
        updatedFields.push({ id, fieldRow: currentFieldRow + 1 })
      }

      if (direction === 'down' && currentFieldRow > sourceFieldRow && currentFieldRow <= targetFieldRow) {
        updatedFields.push({ id, fieldRow: currentFieldRow - 1 })
      }
    }
  }

  return updatedFields
}
